import { gsap } from 'gsap'

/**
 * ドロワーメニューの開閉機能
 */
export class Drawer {
  constructor() {
    this.hamburger = document.getElementById('js-hamburger')
    this.drawer = document.getElementById('js-drawer')
    this.header = document.getElementById('js-header')
    this.body = document.body
    if (this.hamburger === null || this.drawer === null) return

    this.hamburger.addEventListener('click', () => {
      this.toggle()
    })

    // ドロワー内のページ内リンクをクリックしたら閉じる
    const anchorLinks = this.drawer.querySelectorAll('a[href^="#"]')
    anchorLinks.forEach((link) => {
      link.addEventListener('click', () => {
        this.close()
      })
    })
  }

  toggle() {
    this.hamburger.querySelector('span').classList.toggle('hidden')
    this.hamburger.classList.toggle('is-act')
    this.header.classList.toggle('is-act')

    if (this.hamburger.classList.contains('is-act')) {
      this.animation(this.drawer, 'open')
      this.body.classList.add('is-drawer-open')
    } else {
      this.animation(this.drawer, 'close')
      this.body.classList.remove('is-drawer-open')
    }
  }

  close() {
    this.hamburger.querySelector('span').classList.add('hidden')
    this.hamburger.classList.remove('is-act')
    this.header.classList.remove('is-act')
    this.animation(this.drawer, 'close')
    this.body.classList.remove('is-drawer-open')
  }

  animation(el, type) {
    if (type === 'open') {
      gsap.to(el, { duration: 0.2, opacity: 1, display: 'block'})
    } else {
      gsap.to(el, { duration: 0.2, opacity: 0, display: 'none' })
    }
  }
}
